import React, { Component, Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import {inject, observer} from "mobx-react";
import K from '../../../../constants'
import {api} from "../../../../services";
import {PulseLoader} from "react-spinners";
import {message} from "antd";
import MyPageButton from "../../../../common/components/MyPageButton";
import Section from "../../../../common/components/Section";
import PaymentAgreements from "./PaymentAgreements";

@withRouter
@inject('mypageStore', 'productsStore', 'translationsStore')
@observer
class SlimpayIframe extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      success: false,
      iframeContent: null,
      hasConfirmedAgreement: false,
      mandateStatus: 'checking',
      mandateExists: false,
      existingMandateMessage: null,
      processingPayment: false,
      currentDefaultPaymentMethod: null
    }
  }

  isProductMovein = () => {
    return this.props.productsStore.selectedProduct
      ? this.props.productsStore.selectedProduct.features.some(feature => feature.node.name === 'movein')
      : false;
  };

  isProductMoveinRenewal = () => {
    const { selectedProduct } = this.props.productsStore;
    return selectedProduct
        ? selectedProduct.features.some(feature => feature.node.name === 'movein') && selectedProduct.category === 'renew'
        : false;
  };

  isProductRenew = () => {
    return this.props.productsStore.selectedProduct
      ? this.props.productsStore.selectedProduct.features.some(feature => feature.node.name === 'air') && this.props.productsStore.selectedProduct.category === 'renew'
      : false;
  };

  isAssistance = () => {
    const { productsStore } = this.props;
    const { selectedProduct } = productsStore;

    return selectedProduct
      ? productsStore.isAssistance(selectedProduct)
      : false;
  };

  isOptionalAssistance = () => {
    const { productsStore } = this.props;
    const { optionalServiceProduct } = productsStore;

    return optionalServiceProduct
        ? productsStore.isAssistance(optionalServiceProduct)
        : false;
  };

  componentDidMount() {
    api('getSlimpayIframe', this.props.mypageStore.remoteUserData.uuid)
      .then(result => {
        // Handle different response types based on mandate existence
        if (result.type === 'existing_mandate') {
          // User has existing SEPA mandate
          const { translationsStore } = this.props;
          this.setState({
            loading: false,
            mandateStatus: 'exists',
            mandateExists: true,
            existingMandateMessage: translationsStore.translate('paymentView.existingMandateMessage') || result.message || 'A mandate is already associated to this user',
            currentDefaultPaymentMethod: result.currentDefaultPaymentMethod,
            hasConfirmedAgreements: true // Skip the first agreement step for existing mandates
          });
        } else if (result.type === 'iframe' || result.iframe) {
          // User needs to create new mandate - show iframe directly
          this.setState({
            loading: false,
            mandateStatus: 'none',
            mandateExists: false,
            iframeContent: result.iframe,
            hasConfirmedAgreements: true // Skip the redundant button and show iframe directly
          }, () => {
            this.setupWebSocket();
          });
        } else {
          // Fallback for existing implementation (iframe directly in response)
          this.setState({
            loading: false,
            mandateStatus: 'none',
            mandateExists: false,
            iframeContent: result.iframe || result
          }, () => {
            this.setupWebSocket();
          });
        }
      })
      .catch(error => {
        console.error('Error loading Slimpay iframe:', error);
        this.setState({
          loading: false,
          mandateStatus: 'error'
        });
        this.showErrorMessage();
      });
  }

  setupWebSocket = () => {
    const webSocketProtocol = process.env.REACT_APP_ENV === 'local' ? 'ws' : 'wss';
    this.socket = new WebSocket(`${webSocketProtocol}://${K.API_URL.split("//")[1]}`);

    this.socket.addEventListener("open", () => {
      this.socket.send(JSON.stringify({type: "salutation", message: {id: this.props.mypageStore.remoteUserData.zuora_account_id}}));
    });

    this.socket.addEventListener("message", event => {
      try {
        this.onNotification(event.data)
      } catch (e) {
        console.error("error parsing data!");
      }
    });
  }

  onNotification = async () => {
    try {
      const { productsStore } = this.props;
      await productsStore.subscribeToProduct('SEPA');
      let route = `/thankyoupage`;
      if (this.isProductMoveinRenewal()) {
        route = `${route}?movein=true&renewal=true`;
      } else if (this.isProductMovein()) {
        route = `${route}?movein=true`;
      }
      this.props.history.push(route);
    } catch (error) {
      this.showErrorMessage();
    }
  };

  processExistingMandatePayment = async () => {
    this.setState({ processingPayment: true });

    try {
      const { productsStore } = this.props;

      // Process subscription using existing mandate
      await productsStore.subscribeToProduct('SEPA');

      // Navigate to success page
      let route = `/thankyoupage`;
      if (this.isProductMoveinRenewal()) {
        route = `${route}?movein=true&renewal=true`;
      } else if (this.isProductMovein()) {
        route = `${route}?movein=true`;
      }
      this.props.history.push(route);
    } catch (error) {
      console.error('Error processing payment with existing mandate:', error);
      this.setState({ processingPayment: false });
      this.showErrorMessage();
    }
  };

  componentWillUnmount() {
    this.socket && this.socket.close();
  }

  showErrorMessage = () => {
    const { translationsStore } = this.props;
    message.error(translationsStore.translate('common.genericError'));
  };

  formatPaymentMethodDisplay = (paymentMethod) => {
    if (!paymentMethod) {
      return 'SEPA Direct Debit';
    }

    if (paymentMethod.Type === 'BankTransfer' && paymentMethod.BankTransferType === 'SEPA') {
      return {
        displayName: paymentMethod.BankName || 'SEPA Bank Transfer',
        accountMask: paymentMethod.BankTransferAccountNumberMask || '',
        type: 'SEPA Direct Debit'
      };
    }

    return {
      displayName: 'SEPA Direct Debit',
      accountMask: '',
      type: paymentMethod.Type || 'Bank Transfer'
    };
  };

  isAssistance = () => {
    const { productsStore } = this.props;
    const { selectedProduct } = productsStore;

    return selectedProduct
        ? productsStore.isAssistance(selectedProduct)
        : false;
  };

  render() {
    const { translationsStore } = this.props;
    const {
      hasConfirmedAgreements,
      checkedAgreedGeneralConditions,
      checkedAgreedRestrictiveClauses,
      loading,
      mandateExists,
      existingMandateMessage,
      processingPayment,
      mandateStatus,
      currentDefaultPaymentMethod
    } = this.state;
    const isCheckedConditionsRequiredForSelectedProduct = this.isProductMovein() || this.isProductRenew() || this.isAssistance();

    if (loading) {
      return <PulseLoader sizeUnit={'px'} size={20} color={'var(--action-primary-color)'} loading={true} />
    }

    // Handle error state
    if (mandateStatus === 'error') {
      return (
        <div className="mandate-error">
          <p>{translationsStore.translate('common.genericError')}</p>
          <MyPageButton
            theme="primary"
            title={translationsStore.translate('common.retry')}
            onClick={() => window.location.reload()}
          />
        </div>
      );
    }

    // Handle existing mandate scenario
    if (mandateExists) {
      return (
        <Fragment>
          {!hasConfirmedAgreements ? (
            <div>
              {/* Show agreements for products that require them */}
              {this.isProductMovein() && <PaymentAgreements
                checkedAgreedGeneralConditions={checkedAgreedGeneralConditions}
                checkedAgreedRestrictiveClauses={checkedAgreedRestrictiveClauses}
                onChangeAgreedGeneralConditions={checked => {
                  this.setState({ checkedAgreedGeneralConditions: checked });
                }}
                onChangeAgreedRestrictiveClauses={checked => {
                  this.setState({ checkedAgreedRestrictiveClauses: checked });
                }}
              />}
              {this.isProductRenew() && <PaymentAgreements
                checkedAgreedGeneralConditions={checkedAgreedGeneralConditions}
                checkedAgreedRestrictiveClauses={checkedAgreedRestrictiveClauses}
                onChangeAgreedGeneralConditions={checked => {
                  this.setState({ checkedAgreedGeneralConditions: checked });
                }}
                onChangeAgreedRestrictiveClauses={checked => {
                  this.setState({ checkedAgreedRestrictiveClauses: checked });
                }}
                isRenewProduct={this.isProductRenew()}
              />}
              {this.isAssistance() && <PaymentAgreements
                checkedAgreedGeneralConditions={checkedAgreedGeneralConditions}
                checkedAgreedRestrictiveClauses={checkedAgreedRestrictiveClauses}
                onChangeAgreedGeneralConditions={checked => {
                  this.setState({ checkedAgreedGeneralConditions: checked });
                }}
                onChangeAgreedRestrictiveClauses={checked => {
                  this.setState({ checkedAgreedRestrictiveClauses: checked });
                }}
                hideSubTitle={true}
                generalConditionsDocumentSource={K.POLICY_BASE_URL.concat('AIR+-+Condizioni+generali+Servizi+aggiuntivi.pdf')}
                labelRestrictiveConditions={translationsStore.translate('installerView.sectionAgreements.labelRestrictiveClausesAdditionalProduct')}
                labelGeneralConditionPrefix={translationsStore.translate('installerView.sectionAgreements.labelAdditionalGeneralConditionsPrefix')}
                labelGeneralConditionClickable={translationsStore.translate('installerView.sectionAgreements.labelGeneralConditions')}
                labelGeneralConditionSuffix={translationsStore.translate('installerView.sectionAgreements.labelAdditionalGeneralConditionsSuffix')}
                {...((!!this.props.addOnServiceAgreements && !!this.props.onAddOnServiceAgreementsChange)
                  ? {
                    addOnServiceAgreements: this.props.addOnServiceAgreements,
                    onAddOnServiceAgreementsChange: this.props.onAddOnServiceAgreementsChange
                  }
                  : {})}
              />}

              <MyPageButton
                className="PaymentPane"
                theme="primary"
                style={{ marginTop: 40, height: 40, fontSize: 16 }}
                solid
                title={translationsStore.translate('installerView.labelPaymentProceed')}
                disabled={isCheckedConditionsRequiredForSelectedProduct && !(checkedAgreedGeneralConditions && checkedAgreedRestrictiveClauses)}
                onClick={() => this.setState({hasConfirmedAgreements: true})}
              />
            </div>
          ) : (
            <Section className="ExistingMandateContainer">
              <div className="existing-mandate-info">
                <h3>{translationsStore.translate('paymentView.existingMandateTitle') || 'Payment Method Ready'}</h3>
                <p>{existingMandateMessage}</p>

                {/* Display SEPA payment method information */}
                {currentDefaultPaymentMethod && (
                  <div className="payment-method-details" style={{
                    margin: '20px 0',
                    padding: '15px',
                    backgroundColor: '#f8f9fa',
                    border: '1px solid #e9ecef',
                    borderRadius: '6px',
                    textAlign: 'left'
                  }}>
                    <h4 style={{ marginBottom: '10px', color: '#495057' }}>
                      {translationsStore.translate('paymentView.paymentMethodDetails') || 'Payment Method Details'}
                    </h4>
                    <div style={{ marginBottom: '8px' }}>
                      <strong>{this.formatPaymentMethodDisplay(currentDefaultPaymentMethod).displayName}</strong>
                    </div>
                    <div style={{ fontSize: '14px', color: '#6c757d', marginBottom: '5px' }}>
                      {translationsStore.translate('paymentView.accountNumber') || 'Account'}: {this.formatPaymentMethodDisplay(currentDefaultPaymentMethod).accountMask}
                    </div>
                    <div style={{ fontSize: '14px', color: '#6c757d' }}>
                      {translationsStore.translate('paymentView.paymentType') || 'Type'}: {this.formatPaymentMethodDisplay(currentDefaultPaymentMethod).type}
                    </div>
                  </div>
                )}

                {/* Payment completion button */}
                <MyPageButton
                  className="PaymentPane"
                  theme="primary"
                  style={{ marginTop: 20, height: 40, fontSize: 16 }}
                  solid
                  title={processingPayment ?
                    (translationsStore.translate('paymentView.processingPayment') || 'Processing...') :
                    (translationsStore.translate('paymentView.completePayment') || 'Complete Payment')
                  }
                  disabled={processingPayment}
                  onClick={this.processExistingMandatePayment}
                />

                {/* New IBAN and alternative payment message */}
                <div style={{
                  marginTop: 15,
                  padding: '10px',
                  fontSize: '13px',
                  textAlign: 'center',
                  color: '#6c757d'
                }}>
                  {translationsStore.translate('paymentView.newIbanMessage') || 'If you want to use a new IBAN, click'}{' '}
                  <a
                    href="/payment-management"
                    style={{
                      color: '#007bff',
                      textDecoration: 'underline',
                      fontSize: '13px'
                    }}
                    rel="noopener noreferrer"
                  >
                    {translationsStore.translate('paymentView.newIbanLink') || 'here'}
                  </a>
                  {translationsStore.translate('paymentView.alternativePaymentMessage') || '. Alternatively, if you want to use a debit/credit card, you can change the payment method from the list above.'}
                </div>

                {processingPayment && (
                  <div style={{ marginTop: 20, textAlign: 'center' }}>
                    <PulseLoader sizeUnit={'px'} size={10} color={'var(--action-primary-color)'} loading={true} />
                  </div>
                )}
              </div>
            </Section>
          )}
        </Fragment>
      );
    }

    // Handle new mandate creation (original flow)
    let validAgreements = checkedAgreedGeneralConditions && checkedAgreedRestrictiveClauses;
    if (this.props.hasOwnProperty('addOnServiceAgreements') && this.isAssistance()) {
      const {
        addOnServiceAgreements: { air_club_profiling, air_club_marketing, air_club_third_parties },
      } = this.props;
      validAgreements = validAgreements && air_club_profiling !== undefined && air_club_marketing !== undefined && air_club_third_parties !== undefined;
    }
    const disabledPaymentSubmit = !(validAgreements || !isCheckedConditionsRequiredForSelectedProduct);

    return (
      <Fragment>
        { !hasConfirmedAgreements ?
          <div>
            {this.isProductMovein() && <PaymentAgreements
              checkedAgreedGeneralConditions={checkedAgreedGeneralConditions}
              checkedAgreedRestrictiveClauses={checkedAgreedRestrictiveClauses}
              onChangeAgreedGeneralConditions={checked => {
                this.setState({ checkedAgreedGeneralConditions: checked });
              }}
              onChangeAgreedRestrictiveClauses={checked => {
                this.setState({ checkedAgreedRestrictiveClauses: checked });
              }}
            />}
            {this.isProductRenew() && <PaymentAgreements
              checkedAgreedGeneralConditions={checkedAgreedGeneralConditions}
              checkedAgreedRestrictiveClauses={checkedAgreedRestrictiveClauses}
              onChangeAgreedGeneralConditions={checked => {
                this.setState({ checkedAgreedGeneralConditions: checked });
              }}
              onChangeAgreedRestrictiveClauses={checked => {
                this.setState({ checkedAgreedRestrictiveClauses: checked });
              }}
              isRenewProduct={this.isProductRenew()}
            />}
            {this.isAssistance() && <PaymentAgreements
              checkedAgreedGeneralConditions={checkedAgreedGeneralConditions}
              checkedAgreedRestrictiveClauses={checkedAgreedRestrictiveClauses}
              onChangeAgreedGeneralConditions={checked => {
                this.setState({ checkedAgreedGeneralConditions: checked });
              }}
              onChangeAgreedRestrictiveClauses={checked => {
                this.setState({ checkedAgreedRestrictiveClauses: checked });
              }}
              hideSubTitle={true}
              generalConditionsDocumentSource={K.POLICY_BASE_URL.concat('AIR+-+Condizioni+generali+Servizi+aggiuntivi.pdf')}
              labelRestrictiveConditions={translationsStore.translate('installerView.sectionAgreements.labelRestrictiveClausesAdditionalProduct')}
              labelGeneralConditionPrefix={translationsStore.translate('installerView.sectionAgreements.labelAdditionalGeneralConditionsPrefix')}
              labelGeneralConditionClickable={translationsStore.translate('installerView.sectionAgreements.labelGeneralConditions')}
              labelGeneralConditionSuffix={translationsStore.translate('installerView.sectionAgreements.labelAdditionalGeneralConditionsSuffix')}
              {...((!!this.props.addOnServiceAgreements && !!this.props.onAddOnServiceAgreementsChange)
                ? {
                  addOnServiceAgreements: this.props.addOnServiceAgreements,
                  onAddOnServiceAgreementsChange: this.props.onAddOnServiceAgreementsChange
                }
                : {})}
            />}
            <MyPageButton
              className="PaymentPane"
              theme="primary"
              style={{ marginTop: 40, height: 40, fontSize: 16 }}
              solid
              title={translationsStore.translate('installerView.labelPaymentProceed')}
              disabled={disabledPaymentSubmit}
              onClick={() => this.setState({hasConfirmedAgreements: true})}
            />
          </div>
           : (
            <Section
              className="SlimpayIframeContainer"
            >
              <div
                className="SlimpayIframe"
                dangerouslySetInnerHTML={{ __html: this.state.iframeContent}}
              />
            </Section>
          )
        }
      </Fragment>
    )
  }
}

export default SlimpayIframe;
